import axios from 'axios';
import axiosRetry from 'axios-retry';
import moment from 'moment';
import { requestData } from './Analytics';
const oneroomSecuredAPI = axios.create({
    baseURL: ENV.SECURED_API_ENDPOINT,
    timeout: 5000,
    headers: {
        accept: 'application/json',
        'content-type': 'application/json',
        'x-api-key': ENV.API_KEY,
    },
});
const oneroomViewerAPI = axios.create({
    baseURL: ENV.VIEWER_API_ENDPOINT,
    timeout: 5000,
    headers: {
        accept: 'application/json',
        'content-type': 'application/json',
        'x-api-key': ENV.API_KEY,
    },
});
const oneroomFeedbackAPI = axios.create({
    baseURL: ENV.VIEWER_API_ENDPOINT,
    timeout: 5000,
    headers: {
        accept: 'application/json',
        'content-type': 'application/json',
        'x-api-key': ENV.FEEDBACK_APIKEY,
    },
});
axiosRetry(oneroomViewerAPI, {
    retries: 5,
    retryDelay: (retryCount) => {
        return retryCount * 1000;
    },
    retryCondition: (error) => {
        return (axiosRetry.isNetworkOrIdempotentRequestError(error) ||
            (!!error?.response?.status && error.response.status >= 500));
    },
});
export const verifyViewer = async (fingerprint, eventId) => {
    try {
        const response = await oneroomViewerAPI.get('/verify', {
            params: {
                fingerprint,
                eventId,
            },
        });
        console.log('Verify API data', response);
        return true;
    }
    catch (error) {
        console.error('Verify API error', error);
        return false;
    }
};
export const registerViewer = async (eventId, fingerprint, name, email, phone, relationship, zip) => {
    try {
        await oneroomViewerAPI.put('/register', {
            eventId,
            name,
            email,
            phone,
            relationship,
            zip,
            isTnCAccepted: true,
            fingerprint,
            isNameOnly: !email,
        });
        return true;
    }
    catch (error) {
        return false;
    }
};
export const registerViewerName = async (eventId, name, fingerprint) => {
    try {
        const ip = requestData.postData.ip4.split(',')[0];
        console.log('ip:', ip);
        await oneroomViewerAPI.put('/register', {
            eventId,
            name,
            isTnCAccepted: true,
            fingerprint,
            isNameOnly: true,
            ip,
        });
        return true;
    }
    catch (error) {
        return false;
    }
};
export const getPreNeedViewerInfo = async (eventId, fingerprint) => {
    try {
        const response = await oneroomViewerAPI.get('/fingerprintInfo', {
            params: {
                fingerprint,
                eventId,
            },
        });
        console.log('response:', response);
        return response.data;
    }
    catch (error) {
        return false;
    }
};
export const updatePreNeedViewer = async (eventId, name, email, preferredEmail, phone, postCode, preneedOption) => {
    try {
        await oneroomSecuredAPI.post('/preneed/registerPreneedInterest', {
            eventId,
            name,
            email,
            preferredEmail,
            phone,
            postCode,
            preneedInterest: 'YES',
            preneedOption,
        });
        return true;
    }
    catch (error) {
        return false;
    }
};
export const getDonations = async (eventId) => {
    const response = await oneroomViewerAPI.get('/donations', {
        params: {
            eventId,
        },
    });
    return response.data;
};
export const submitFeedback = async (fingerprint, score, feedback) => {
    try {
        const utcTime = moment().utc().format('YYYY-MM-DDTHH:mm:ss');
        await oneroomFeedbackAPI.post('/form/createFeedback', {
            eventId: Number(eventDataProps.data.id),
            venueId: Number(eventDataProps.data.venue.id),
            organizationId: eventDataProps.data.venue.organization_id ? Number(eventDataProps.data.venue.organization_id) : null,
            fingerprintId: fingerprint,
            score,
            feedback: feedback ?? '',
            createdAt: utcTime,
            updatedAt: utcTime,
        });
        return true;
    }
    catch (error) {
        return false;
    }
};
